<template>
  <div class="wrap">
    <div class="container">
      <h3 class="personal_titile">更改密码</h3>
      <div class="adddz chardz">
        <form>
          <div class="address_require">
            <label>当前密码<span>*</span></label>
            <input type="password" v-model="my_pwd" >
          </div>
          <div class="address_require">
            <label>新密码<span>*</span></label>
            <input type="password" v-model="new_pwd" >
          </div>
          <div class="address_require">
            <label>确认新密码<span>*</span></label>
            <input type="password" v-model="confirm_new_pwd" >
          </div>
        </form>
      </div>
      <br/>
      <van-row type="flex" align="center" justify="center">
        <van-col span="20">
          <van-button block type="primary" v-on:click="bt_change()">保存</van-button>
        </van-col>
      </van-row>
    </div>
    <v-foot></v-foot>
  </div>
</template>
<style>

</style>
<script>
	var _this;
  export default {
    components: {},
	created(){
		this.getUserInfo(true);
		_this = this;
	},
    data() {
		return {
			"my_pwd":"",
			"new_pwd":"",
			"confirm_new_pwd":"",
      }
    },
    methods: {
		bt_change(){
			this.POST("api/user/loginpwdupdate",{"my_pwd":this.my_pwd,"new_pwd":this.new_pwd,"confirm_new_pwd":this.confirm_new_pwd},function(d){
				window.console.log(d);
				_this.$toast(d.msg);
				if(d.code == 0){
					_this.$router.push('personal');
				}
			});
		}

    },
  }
</script>